import { useTranslation } from 'react-i18next'

function ErrorPage() {
    const { t } = useTranslation()

    return (
        <div className="grid h-screen w-full place-items-center">
            <div className="flex flex-col content-center items-center ">
                <h1 className="text-center">{t('error_page.title')}</h1>
                <h4 className="mt-8">{t('error_page.subtitle')}</h4>
                <p className="mt-4 text-center">
                    {t('error_page.filler')}{' '}
                    <a className="underline" href="mailto:help@itsrever.com">
                        help@itsrever.com
                    </a>
                </p>
            </div>
        </div>
    )
}
export default ErrorPage
